import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DropIn from 'braintree-web-drop-in-react';
import { getApiHeader } from 'utlis/commonfunctions';
import Alert from '@mui/material/Alert';
import { Box, Button, TextField, Typography, Grid, Card, CardActionArea, Backdrop, CircularProgress } from '@mui/material';
import checkbox from 'assets/theme/components/form/checkbox';


const Payment = ({ nextStep, prevStep, selectedPrepaidPlanId, rechargeType, rechargeData, getFinalStep }) => {
     console.log("rechargeData",rechargeData)

  const rechargeSessionId = sessionStorage.getItem("rechargeSessionId")
  const SERVER_URL = process.env.REACT_APP_API_URL;
  const [clientToken, setClientToken] = useState('');
  const instanceRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [disable, setDisabled] = useState(false)
  const [checkBox, setCheckBox] = useState(false)
  const [checkBoxError, setCheckBoxError] = useState(false)
  const [defaultCard, setdefaultCard] = useState("")
  const [existingCard, setExistingCard] = useState(0)
  const [showPayment, setShowPayment] = useState(false);
  const displayedAmount = rechargeData?.wallet_used_amount > 0
  ? rechargeData.after_credit_amount
  : rechargeData?.customer_credit_amount !== null && rechargeData?.customer_credit_amount !== undefined
    ? Number(rechargeData?.customer_credit_amount).toFixed(2)
    : rechargeData?.original_plan_amount !== null && rechargeData?.original_plan_amount !== undefined
      ? Number(rechargeData?.original_plan_amount).toFixed(2)
      : rechargeData?.retailer?.recharge_discount_amount;




  useEffect(() => {
    fetchDefaultCard();
    
    console.log("showPayment-->",displayedAmount);
    
  }, [rechargeData]);




  const fetchDefaultCard = async () => {
    const headers = await getApiHeader();
    try {
        const response = await axios.get(`${SERVER_URL}retailer-default-card`, {
            headers: headers,
        });

        if (response?.status === 200) {
            const paymentMethods = response?.data?.data?.payment_methods;
            if (typeof paymentMethods === "object" && !Array.isArray(paymentMethods) && paymentMethods !== null) {
                setdefaultCard(paymentMethods);
                setExistingCard(1);
                setLoading(false);
            } else {
                fetchToken();
            }
        } else {
            fetchToken();
        }
    } catch (error) {
        fetchToken();
    }
};







  const fetchToken = async () => {
    const headers = await getApiHeader();
    try {
      setLoading(true)
      const response = await axios.get(`${SERVER_URL}prepaid-recharge/payments/get-client-token`, {
        headers: headers,
      });
      if (response.status === 200) {
        const clientToken = response.data.data.clientToken;
        setClientToken(clientToken);
         setTimeout(()=>{setLoading(false)},3000)
        
      }
    } catch (error) {
      setLoading(false)
      console.error('Error fetching client token:', error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checkBox) {
      setCheckBoxError(true);
      setDisabled(true);
      return;
    }

    setDisabled(true)
    if (!instanceRef.current) {
      return console.error('Braintree DropIn instance is not initialized');
    }

    setLoading(true);

    try {
      const { nonce } = await instanceRef.current.requestPaymentMethod();
      const paymentData = {
        nonce: nonce,
        session_id: rechargeSessionId,
        plan_id: selectedPrepaidPlanId,
        recharge_type: rechargeType,
      }

      // Here you can make an API call to your server to complete the payment process with the nonce
      const headers = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}prepaid-recharge/recharge`, paymentData, { headers });

      console.log('Payment response:', response.data);
      let message = response?.data?.message
      if (message) {
        swal("Success", message);
      }
      if (response.status === 200) {
        if (message) {
          swal("Success", message).then(() => {
            getFinalStep(1);
          });
        }
      }
   
    } catch (error) {
      setDisabled(false)
      const message = error?.response?.data?.message
      if (message) {
        swal("Error", message).then(() => {
          getFinalStep(1);
        });

      }
    } finally {
      setLoading(false);
    }
  };







  const handleZeroPlans = async (e) => {
    e.preventDefault()

    if (!checkBox) {
      setCheckBoxError(true);
      setDisabled(true);
      return;
    }

    setLoading(true);
    try {
      const paymentData = {
        session_id: rechargeSessionId,
        plan_id: selectedPrepaidPlanId,
        recharge_type: rechargeType,
        default_Card: existingCard
      }

      // Here you can make an API call to your server to complete the payment process with the nonce
      const headers = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}prepaid-recharge/recharge`, paymentData, { headers });
      let message = response?.data?.message
      if (message) {
        swal("Success", message);
      }
      if (response.status === 200) {
        setLoading(false);
        if (message) {
          swal("Success", message).then(() => {
            getFinalStep(1);
          });
        }
      }

    } catch (error) {
      setDisabled(false)
      setLoading(false);
      const message = error?.response?.data?.message
      if (message) {
        swal("Error", message).then(() => {
          getFinalStep(1);
        });

      }
    } finally {
      setLoading(false);
    }


  }


  const handlePaymentOptions = async (event) => {
    event.preventDefault()
    if (displayedAmount < 1 || existingCard == 1) {
      await handleZeroPlans(event)

    } else {
      await handleSubmit(event)
    }
  }


  // const handleCheckBox = () => {
  //   setCheckBoxError(true)
  //   setDisabled(false)
  //   setCheckBox(false)
  // }

  const handleCheckBox = () => {
    setCheckBox((prevCheckBox) => {
      const newCheckBoxState = !prevCheckBox;

      if (newCheckBoxState) {
        // If checked, clear error and enable button
        setCheckBoxError(false);
        setDisabled(false);
      } else {
        // If unchecked, set error and disable button
        setCheckBoxError(true);
        setDisabled(true);
      }

      return newCheckBoxState;
    });
  }




  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />
        {loading && (
          <Backdrop
            open={true}
            style={{
              color: "#fff",
              zIndex: 9999,
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <div className="formbold-form-wrapper add-plan-form">
                <h6 className="text-center mb-4">Payment</h6>
                <hr />

                <form onSubmit={handlePaymentOptions}>
                  <div className="row mb-4">
                    <div className="col-12">
                      {displayedAmount > 0  && (
                        defaultCard && existingCard === 1 ? (
                          <div className="recharge-defaultCard col-lg-12">
                            <div className="recharge-defaultCardBox">
                              <p>Paying With Card</p>
                              <ul className="recharge-defaultCardDetails">
                                <li>
                                  <img src={defaultCard.imageUrl} alt="Card" />
                                </li>
                                <li>
                                  <span>Ending In {defaultCard.last4}</span>
                                  <span>{defaultCard.cardType}</span>
                                </li>
                                <li>{/* Additional content can go here */}</li>
                              </ul>
                            </div>
                          </div>
                          
                        ) : clientToken ? (
                            <>
               <label className='dealer-responsive-label' >Please use payment card details of dealer. Do not use customer payment card details here. </label>

                              <DropIn
                                options={{ authorization: clientToken }}
                                onInstance={(instance) => (instanceRef.current = instance)}
                              />
                            </>
                         
                        ) : (
                          <p>Please wait while the payment gateway is loading...</p>
                        )
                      ) }


                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-12">
                      <div className="pay-btree-block">
                        <div className="table-responsive">


                          <table className="table">
                            <thead>
                              <tr>
                                <th>DESCRIPTION</th>
                                <th>AMOUNT DUE</th>
                              </tr>
                            </thead>
                            <tbody>

                              <tr><td>{rechargeData.plan_name} RRP</td>
                                <td> ${rechargeData?.original_plan_amount}</td></tr>

                              {rechargeData?.idd_offer_pack_amount && (
                                <tr><td>Retailer discount amount</td>
                                  <td> ${rechargeData?.idd_offer_pack_amount}</td></tr>
                              )}

                              {rechargeData?.retailer && (
                                <>
                                  <tr>
                                    <td>Retailer Discount
                                    </td>
                                    <td> {rechargeData?.retailer?.recharge_discount_percentage}%</td>
                                  </tr>
                                </>

                              )}
                              {rechargeData?.customer_discount_amount != null && (
                                <tr>
                                  <td>Customer Discount Amount</td>
                                  <td>
                                    {rechargeData?.customer_credit_amount < 1 ? "100%" : `$${Number(rechargeData?.customer_discount_amount).toFixed(2)}`}
                                  </td>
                                </tr>
                              )}


                              {rechargeData?.wallet_used_amount != null && (
                                <tr>
                                  <td>Wallet Amount Used</td>
                                  <td>{`$${Number(rechargeData?.wallet_used_amount).toFixed(2)}`}</td>
                                </tr>
                              )}




                              {rechargeData?.retailer && (
                                <tr>
                                  <td> Dealer Price
                                  </td>

                                  <td>
                                    {/* ${rechargeData?.customer_credit_amount !== null && rechargeData?.customer_credit_amount !== undefined ? Number(rechargeData?.customer_credit_amount).toFixed(2) : rechargeData?.retailer?.recharge_discount_amount} */}

                                    ${
                                      rechargeData?.wallet_used_amount > 0
                                        ? Number(rechargeData.after_credit_amount).toFixed(2)
                                        : (rechargeData?.customer_credit_amount !== null && rechargeData?.customer_credit_amount !== undefined
                                          ? Number(rechargeData?.customer_credit_amount).toFixed(2)
                                          : Number(rechargeData?.retailer?.recharge_discount_amount).toFixed(2))
                                    }

                                  </td>

                                  {/* <td> ${ rechargeData?.customer_credit_amount?rechargeData?.customer_credit_amount: rechargeData?.retailer?.recharge_discount_amount}</td> */}
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>


                        <div className="recharge-total">
                          <div>
                            <span className="recharge-total-tittle ">TOTAL AMOUNT :</span><br />
                          </div>
                          <div style={{ paddingLeft: "10px" }}>
                            {/* 
                            {rechargeData?.retailer ? (
                              <>
                                <span className="recharge-total-amount">
                                  ${rechargeData?.retailer?.recharge_discount_amount}
                                </span>
                              </>
                            ) : (
                              <span className="recharge-total-amount">            
                         ${rechargeData.idd_offer_pack_amount ? rechargeData.idd_offer_pack_amount : rechargeData?.original_plan_amount}
                              </span>
                            )} */}

                            <span className="recharge-total-amount">
                              {/* {rechargeData?.customer_credit_amount !== null && rechargeData?.customer_credit_amount !== undefined
                                ? `$${Number(rechargeData?.customer_credit_amount).toFixed(2)}`
                                : rechargeData?.retailer
                                  ? `$${rechargeData?.retailer?.recharge_discount_amount}`
                                  : `$${rechargeData?.idd_offer_pack_amount ? rechargeData.idd_offer_pack_amount : rechargeData?.original_plan_amount}`} */}

                              {
                                rechargeData?.wallet_used_amount > 0
                                  ? `$${Number(rechargeData.after_credit_amount).toFixed(2)}`
                                  : rechargeData?.customer_credit_amount !== null && rechargeData?.customer_credit_amount !== undefined
                                    ? `$${Number(rechargeData?.customer_credit_amount).toFixed(2)}`
                                    : rechargeData?.retailer
                                      ? `$${Number(rechargeData?.retailer?.recharge_discount_amount).toFixed(2)}`
                                      : `$${Number(
                                        rechargeData?.idd_offer_pack_amount
                                          ? rechargeData.idd_offer_pack_amount
                                          : rechargeData?.original_plan_amount
                                      ).toFixed(2)}`
                              }


                            </span>
                          </div>
                        </div>

                        <br /><br />
                        <div className="kt-invoice__footer kt-padding-10">
                          <span className="amount-tittle"><i>
                            *All amounts are mentioned in AUD</i>
                          </span>
                        </div>

                        <label className="check-box add-mb-accept-pay">
                          I have read and accept the{' '}
                          <a
                            target="_blank"
                            href="https://www.telsim.com.au/website-terms-conditions/"
                            rel="noopener noreferrer"
                          >
                            Terms & Conditions
                          </a>
                          , the Acceptable Use Policy, and the{' '}
                          <a
                            target="_blank"
                            href="https://www.telsim.com.au/website-privacy-policy/"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </a>{' '}
                          for my Telsim service.
                          <input
                            type="checkbox"
                            required=""
                            id="agreeTerms"
                            title="Please check and agree to the terms and conditions"
                            onChange={handleCheckBox}
                          />

                          {checkBoxError && !checkBox && (
                            <p className="error-label">Please check and agree to the terms and conditions</p>
                          )}

                          <span className="tick"></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <button
                        className="btn payment-Button w-100"
                        onClick={prevStep}
                        type="button" // So it doesn't trigger form submission
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="btn  payment-Button w-100"
                        type="submit"
                        disabled={disable}
                      >
                        {loading ? 'Processing...' : 'Pay Now'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </div>
  );
};

export default Payment;
